module.exports = __webpack_public_path__ + "static/media/EidMilanParty.4df17312.jpeg";